import {
  HOUR,
  isNotEmpty,
  WEEK,
  type FeatureConfigInput,
  type FeatureConfigSuccess,
  type FeatureId,
} from '@terros/common'
import { type GetHookResponse } from '../hooks'
import { featureKey } from '../keys'
import { useTantalimQuery } from '../query'
import { toValidFeatureFlagNumber } from './parse'

export function useFeatureConfig(input: FeatureConfigInput, enabled = true): GetHookResponse<FeatureConfigSuccess> {
  return useTantalimQuery<FeatureConfigInput, FeatureConfigSuccess, FeatureConfigSuccess>({
    url: '/feature/config',
    queryKey: featureKey(input.featureId),
    input,
    convertResponse: (data) => data,
    options: {
      enabled: enabled && isNotEmpty(input.featureId),
      gcTime: WEEK,
      staleTime: HOUR,
    },
  })
}

export function useFeatureConfigNumber(
  featureId: FeatureId,
  fallback: number
): Omit<GetHookResponse<number>, 'data'> & { data: number } {
  const { data, ...state } = useFeatureConfig({ featureId, fallback })
  return {
    ...state,
    data: toValidFeatureFlagNumber(data?.value, fallback),
  }
}
